export default "__VITE_ASSET__1d222b15__"